export default class CitiesTransformation {
  static transformCity(data) {
    const { id, title } = data;
    return { title, id };
  }

  static transformListOfCities(listOfCities = []) {
    return listOfCities.map((city) => this.transformCity(city));
  }
}
